import { fileUploadContext } from "@contexts/file_upload";
import { useContext } from "react";

function useFileUploadContext() {
  const data = useContext(fileUploadContext);
  return data;
}

export default useFileUploadContext;
